module.exports = __webpack_public_path__ + "img/live06.48c5ebf7.png";